<template>
<div class="chapter">
<div class="inner_page">
<blockquote epub:type="epigraph" role="doc-epigraph">
<p class="linespace" id="ep"> </p>
<p class="ep-bot">My life is very<i>—big!</i></p>
<blockquote epub:type="epigraph" role="doc-epigraph">
<p class="epc"><i>—Kimora Lee Simmons</i></p>
</blockquote>
</blockquote>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// epigraph.vue?472dfc36